import React from 'react';
import { Layout } from 'antd';

import Content from '../../../components/Pages/Records/Update';
import { displayName } from '../../../config';
import RecordsUpdateProvider from '../../../context/recordUpdate';

const RecordsUpdate: React.FC = (): JSX.Element => {
  document.title = `${displayName}: Edit Record`;

  return (
    <Layout>
      <RecordsUpdateProvider>
        <Content />
      </RecordsUpdateProvider>
    </Layout>
  );
};

export default RecordsUpdate;
